// @ts-nocheck

import { colors } from '@lmc/common/constants'
import { Button, Spinner } from '@lmc/ui-kit'
import { css, StyleSheet } from 'aphrodite/no-important'
import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { isBrowser, isTablet } from 'react-device-detect'
import { Link } from 'react-router-dom'

class OldButton extends Component<any, any> {
  constructor(props) {
    super(props)
    const commonStyles = {
      color: colors.black,
      border: 'none',
      textShadow: 'none !important',
      transition: 'all .3s ease'
    }
    const { disabled } = props
    const boxShadow = '0 2px 4px rgba(34,34,34,0.15)'
    const boxShadowLight = '0 2px 4px rgba(34,34,34,0.05)'

    this.classes = StyleSheet.create({
      add: {
        ...commonStyles,
        background: `${colors.successgreen}!important`,
        color: 'white !important',
        ':hover': {
          background: `${colors.successgreen}!important`,
          boxShadow,
          color: 'white !important'
        },
        ':focus': {
          color: 'white !important',
          boxShadow: boxShadowLight
        }
      },
      back: {
        ...commonStyles,
        background: 'Transparent',
        color: colors.red,
        ':hover': {
          color: colors.red
        }
      },
      cancel: {
        ...commonStyles,
        background: colors.grey,
        ':hover': {
          background: colors.lightgrey,
          boxShadow
        },
        ':focus': {
          color: colors.darkgrey,
          boxShadow: boxShadowLight
        }
      },
      confirm: {
        ...commonStyles,
        background: `${colors.green}!important`,
        color: 'white !important',
        ':hover': {
          background: `${colors.green}!important`,
          boxShadow,
          color: 'white !important'
        },
        ':focus': {
          color: 'white !important',
          boxShadow: boxShadowLight
        }
      },
      delete: {
        ...commonStyles,
        background: 'Transparent',
        ':hover': {
          background: colors.red,
          boxShadow,
          color: 'white'
        },
        ':focus': {
          color: 'white',
          boxShadow: colors.red
        }
      },
      draft: {
        ...commonStyles,
        background: colors.orange,
        color: 'white',
        ':hover': {
          background: colors.orange,
          boxShadow,
          color: 'white'
        },
        ':focus': {
          color: 'white',
          boxShadow: boxShadowLight
        }
      },
      edit: {
        ...commonStyles,
        background: `${colors.successgreen}!important`,
        ':hover': {
          background: `${colors.successgreen}!important`,
          boxShadow
        },
        ':focus': {
          boxShadow: boxShadowLight
        }
      },
      primary: {
        ...commonStyles,
        background: `${colors.pink}!important`,
        color: 'white !important',
        ':hover': {
          background: `${colors.pink}!important`,
          boxShadow
        },
        ':focus': {
          boxShadow: boxShadowLight
        }
      },
      resend: {
        ...commonStyles,
        background: `${colors.grey}!important`,
        color: disabled ? colors.white : colors.black,
        ':hover': {
          background: `${colors.lightgrey}!important`,
          boxShadow
        },
        ':focus': {
          boxShadow: boxShadowLight
        }
      },
      success: {
        ...commonStyles,
        background: `${colors.successgreen}!important`,
        color: 'white !important',
        ':hover': {
          background: `${colors.successgreen}!important`,
          boxShadow
        },
        ':focus': {
          boxShadow: boxShadowLight
        }
      }
    })
  }

  renderBody = () => {
    const { children, loading, text } = this.props
    if (loading) return <Spinner />
    if (children) return children
    return text
  }

  render() {
    const {
      className,
      disabled,
      id,
      href,
      link,
      onClick,
      style,
      target,
      type = 'edit'
    } = this.props

    const isDesktop = isBrowser || isTablet

    return (
      <Button
        className={
          className
            ? `${css(this.classes[type])} ${className}`
            : css(this.classes[type])
        }
        component={link ? Link : null}
        disabled={disabled}
        href={href}
        id={id || null}
        onClick={onClick || null}
        position={isDesktop ? 'left' : 'default'}
        style={style}
        target={target}
        to={link || null}
      >
        {this.renderBody()}
      </Button>
    )
  }
}

OldButton.propTypes = {
  className: PropTypes.string,
  disabled: PropTypes.bool,
  href: PropTypes.string,
  id: PropTypes.string,
  link: PropTypes.string,
  loading: PropTypes.bool,
  onClick: PropTypes.func,
  style: PropTypes.object,
  target: PropTypes.string,
  text: PropTypes.string,
  type: PropTypes.oneOf([
    'add',
    'cancel',
    'confirm',
    'delete',
    'draft',
    'edit',
    'back',
    'primary',
    'success',
    'resend'
  ])
}

export default OldButton
